module.exports = __webpack_public_path__ + "media/packs/images/state/small/pol-a2c3ff988f41d7777b361c3ab1792d6a.svg";